<template>
    <el-dialog class="editor-dialog" :title="'PC'+ String(model.seq).padStart(5, '0')+'采购单详情'" append-to-body :visible.sync="visible" :show-close="false" width="60%" top="3vh">
    <el-descriptions class="description" direction="vertical" :column="2" border>
      <el-descriptions-item labelClassName='label-style'>
        <template slot="label">
          采购描述
        </template>
        <span class="content">{{ model.description}}</span>
      </el-descriptions-item>
      <el-descriptions-item labelClassName='label-style'>
        <template slot="label">
          采购项数 | 物料总数
        </template>
        <el-tag type="primary" effect="plain" style="margin-right:3px">{{ model.list.length }}</el-tag>
        <el-tag type="success" effect="plain">{{ totalQty }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item labelClassName='label-style'>
        <template slot="label">
          最长交货期(天)
        </template>
        <span class="content">{{ maxDeliveryTime }}</span>
      </el-descriptions-item>
      <el-descriptions-item labelClassName='label-style'>
        <template slot="label">
          采购金额
        </template>
        <span class="content">{{ totalPurchaseAmount }}</span>
      </el-descriptions-item>    
      <el-descriptions-item labelClassName='label-style'>
        <template slot="label">
          合同金额
        </template>
        <span class="content">{{ totalContractAmount }}</span>
      </el-descriptions-item> 
      <el-descriptions-item labelClassName='label-style'>
        <template slot="label">
          发票金额
        </template>
        <span class="content">{{ totalInvoiceAmount }}</span>
      </el-descriptions-item> 
      <el-descriptions-item labelClassName='label-style'>
        <template slot="label">
          增值税额
        </template>
        <span class="content">{{ totalVATAmount }}</span>
      </el-descriptions-item> 
      <el-descriptions-item labelClassName='label-style'>
        <template slot="label">
          已付款额
        </template>
        <span class="content">{{ totalPaymentAmount }}</span>
      </el-descriptions-item> 
      <el-descriptions-item labelClassName='label-style'>
        <template slot="label">
          采购说明
        </template>
        <el-input type="textarea" v-model="model.remark" size="small" v-if="isEditable" style="width:100%"></el-input>
        <span class="content" v-else >{{ model.remark }}</span>
      </el-descriptions-item>        
    </el-descriptions>
    </el-dialog>
  </template>
  <script>
  import http from '@/http'
  export default {
  data() {
    return {
      visible: false,
      purchaseId:'',
      model:{list:[]}
    };
  },
  computed:{
    totalQty(){
      const totalQty=this.model.list.reduce((pre,cur)=>{
          return pre+(cur.quantity?Number(cur.quantity):0)
        },0)
      return totalQty
    },
    totalPurchaseAmount(){
      const totalCNY=this.model.list.reduce((pre,cur)=>{
          return pre+(cur.quantity&&cur.purchaseUnitPrice&&cur.purchaseCurrency=='CNY'?cur.quantity*cur.purchaseUnitPrice:0)
        },0)
      const totalUSD=this.model.list.reduce((pre,cur)=>{
        return pre+(cur.quantity&&cur.purchaseUnitPrice&&cur.purchaseCurrency=='USD'?cur.quantity*cur.purchaseUnitPrice:0)
      },0)
      return totalCNY.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })+'+'+totalUSD.toLocaleString('en-US', { style: 'currency', currency:'USD' })
    },
    totalContractAmount(){
      const totalCNY=this.model.contractList.reduce((pre,cur)=>{
          return pre+(cur.currency=='CNY'?cur.contractAmount:0)
        },0)
      const totalUSD=this.model.contractList.reduce((pre,cur)=>{
        return pre+(cur.currency=='USD'?cur.contractAmount:0)
      },0)
      return totalCNY.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })+'+'+totalUSD.toLocaleString('en-US', { style: 'currency', currency:'USD' })
    },
    totalInvoiceAmount(){
      const totalCNY=this.model.invoiceList.reduce((pre,cur)=>{
          const b=this.model.contractList.find(item=>item._id==cur.contractId)
          return pre+(b.currency=='CNY'?cur.amount:0)
        },0)
      const totalUSD=this.model.invoiceList.reduce((pre,cur)=>{
        const b=this.model.contractList.find(item=>item._id==cur.contractId)
        return pre+(b.currency=='USD'?cur.amount:0)
      },0)
      return totalCNY.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })+'+'+totalUSD.toLocaleString('en-US', { style: 'currency', currency:'USD' })
    },
    totalVATAmount(){
      const totalCNY=this.model.invoiceList.reduce((pre,cur)=>{
          const b=this.model.contractList.find(item=>item._id==cur.contractId)
          return pre+(b.currency=='CNY'?((cur.taxRate/100)*(cur.amount/(1+cur.taxRate/100))):0)
        },0)
      const totalUSD=this.model.invoiceList.reduce((pre,cur)=>{
        const b=this.model.contractList.find(item=>item._id==cur.contractId)
        return pre+(b.currency=='USD'?((cur.taxRate/100)*(cur.amount/(1+cur.taxRate/100))):0)
      },0)
      return totalCNY.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })+'+'+totalUSD.toLocaleString('en-US', { style: 'currency', currency:'USD' })
    },
    totalPaymentAmount(){
      const totalCNY=this.model.paymentList.reduce((pre,cur)=>{
          const b=this.model.contractList.find(item=>item._id==cur.contractId)
          return pre+(b.currency=='CNY'?cur.amount:0)
        },0)
      const totalUSD=this.model.paymentList.reduce((pre,cur)=>{
        const b=this.model.contractList.find(item=>item._id==cur.contractId)
        return pre+(b.currency=='USD'?cur.amount:0)
      },0)
      return totalCNY.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' })+'+'+totalUSD.toLocaleString('en-US', { style: 'currency', currency:'USD' })
    },
    maxDeliveryTime(){
      let maxDeliveryTime=0
      this.model.list.forEach(item=>{
        if(item.deliveryTime>maxDeliveryTime){
          maxDeliveryTime=item.deliveryTime
        }
      })
      return maxDeliveryTime
    },
  },
  methods:{
    async fetchPurchase() {
      const res = await http.get(`purchase/purchase/id/${this.purchaseId}`);
      this.model = res.data[0]
    }
  },
  created(){
    this.fetchPurchase()
  }
  };
  </script>
  <style scoped>
  .editor-dialog>>>.el-dialog__header {
    text-align: center !important;
    padding:15px 5px 5px 5px;
  }
  .editor-dialog>>>.el-dialog__body {
    padding:20px 10px;
  }
  .editor-dialog>>>.el-dialog__title {
    font-weight: 700 !important;
  }
  .editor-dialog>>>.el-textarea__inner{
    font-family: Arial, Helvetica, sans-serif;
  }
  .editor-dialog>>>.el-descriptions__header{
    display: none;
  }
  .content{
    display:inline-block;
    height:15px!important;
    padding: 0;
  }
  </style>
  